import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { AirportI18nAll } from '@common/interfaces/master/airport_i18n_all';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { TripSummaryService } from '@common/services/my-booking/trip-summary.service';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import { GetOrderResponseData, Type1 } from 'src/sdk-servicing';

@Component({
  selector: 'asw-arrival',
  templateUrl: './arrival.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrivalComponent extends SupportComponent {
  @Input() boundIdx!: number;
  @Input() flightIdx!: number;

  flight: Type1 = {};

  private _subscriptions = new Subscription();
  private _airportI18nAll: Array<AirportI18nAll> = [];

  constructor(
    public tripSummarySvc: TripSummaryService,
    private _myBookingItineraryService: MyBookingItineraryService,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private _change: ChangeDetectorRef,
    private _common: CommonLibService
  ) {
    super(_common);
  }

  override init(): void {
    this._subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        const pnr = (servicingCommon.getOrder as GetOrderResponseData) ?? {};
        this.flight = pnr.air?.bounds?.at(this.boundIdx)?.flights?.at(this.flightIdx) ?? {};
        this._change.markForCheck();
      })
    );
    this._subscriptions.add(
      this._myBookingItineraryService.masterData$.subscribe((result) => {
        this._airportI18nAll = result.airportI18nAll ?? [];
        this._change.markForCheck();
      })
    );
  }

  // (1.1.52) 到着地
  getArrivalLocationName(locationCode: string = '', locationName: string = ''): string {
    // 1) 当該セグメント情報.arrival.locationCodeを基に「イベントID(1)」で取得した空港リストをフィルタして、空港名称を取得する。
    const airportName =
      this._airportI18nAll?.find((item: AirportI18nAll) => item?.airport_code === locationCode)?.airport_name ?? '';
    // 2) 取得できない場合は当該セグメント情報.arrival.locationNameを表示する。
    return airportName || locationName;
  }

  override reload(): void {
    // Add comment to passed SonarLint
  }

  override destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }
}
